import CwVideoView from "./index.vue"

export default CwVideoView